
<div class="modal active projSettings">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Project Management</h2>
      <div class="close" (click)="cancelProjectManagement()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
          <div class="row scroll" >
            <div class="row__item">
              <div *ngFor="let project of this.projectController.projects">
                <p [ngClass]="project.selected? 'selected' : ''" (click)="projController.selectProject(project)">
                  {{ project.editable ? project.name : project.name + ' - uneditable' }}
                  <span (click)="activateProject(project)" [ngClass]="project.active? 'active' : ''">ACTIVE</span>
                </p>
              </div>
            </div>
          </div>
          <div class="btn" *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser)">
           <!-- <div title="Import Project" class="importFile" [ngClass]="'active'" (click)="upload.click()">
              <input id="import" hidden type="file" #upload (change)="importProjectTrigger($event)"/>
            </div>-->
<!--            <div title="Export Project" class="exportFile" [ngClass]="this.projectController.selectedProject ? 'active' : ''" (click)="exportProject()"></div>-->
            <div title="New Project" class="newProj" (click)="addProjectTrigger()" ></div>
            <div title="Edit Project" class="editProj"  [ngClass]="this.projectController.selectedProject != undefined && this.projController.projectEditable(this.projController.selectedProject, false) ? 'active' : ''" (click)="editProjectTrigger()" ></div>
            <div title="Delete Project" class="deleteProj" [ngClass]="this.projectController.selectedProject != undefined && this.projController.selectedProject.name != 'Default' ? 'active' : ''" (click)="deleteProjectTrigger()" ></div>
          </div>
      </div>
    </div>
  </div>
</div>

